import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Subscription } from 'rxjs';
import { BlogpageService } from '../../blogpage.service';
import { RelatedArticle } from 'src/app/shared/utilities/interfaces';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-re-article',
  templateUrl: './re-article.component.html',
  styleUrls: ['./re-article.component.scss'],
  imports: [CommonModule, UrlParamsPipe],
})
export class ReArticleComponent implements OnInit, OnDestroy {
  @Input() pageData: any;
  @ViewChild('registerLink') registerLink: any;
  queryParams: any;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private contentful: ContentfulService,
    private blogPageService: BlogpageService,
    private route: ActivatedRoute
  ) {
    this.subscriptions = [];
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  articleData!: RelatedArticle;

  ngOnInit(): void {
    // this.blogPageService.articlePageData$.subscribe(data => {
    //   if (data) {
    //     this.articleData = {
    //       cards: data?.blogElements ?? data?.fields?.blogElements,
    //       sectionHeader: data?.sectionTitle ?? data?.fields?.sectionTitle,
    //     };
    //   }
    // });
  }
  ngOnChanges(): void {
    const data = this.pageData?.fields;
    if (data) {
      this.articleData = {
        cards: data?.blogElements ?? data?.fields?.blogElements,
        sectionHeader: data?.sectionTitle ?? data?.fields?.sectionTitle,
      };
    }
  }
  openPage(url: string) {
    const isServer = !isPlatformBrowser(this.platformId);
    if (isServer) return;
    let link = '/About-Us/Resources/Blog/Article/' + url;
    window.open(link, '_self');
  }
}
